// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import GooglePlusSquareFilledSvg from "@fishx/icons-svg/es/asn/GooglePlusSquareFilled";
import FishxIcon from '../components/FishxIcon';

var GooglePlusSquareFilled = function GooglePlusSquareFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: GooglePlusSquareFilledSvg
  }));
};

GooglePlusSquareFilled.displayName = 'GooglePlusSquareFilled';
export default React.forwardRef(GooglePlusSquareFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/GooglePlusSquareFilled.js
// module id = 2902
// module chunks = 0